import { Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import ContactUnlockButton from '@/components/contact/rail/ContactUnlockButton';
import { PlanLocksBanner } from '@/components/plan-locks/PlanLocksBanner';
import type { ProfileUnlockTarget } from '@/hooks/actions/use-unlock-creator-profile-action';
import { useProfileUnlockQuota } from '@/hooks/queries/use-profile-unlock-quota';

const K = 'invitations.modal.collab.wizard.send.channelPicker.email';

/**
 * What the channel step offers when the plan masks a creator's address: one
 * of the month's profile unlocks while some are left (the drawer's own unlock
 * button), else the Essential offer. Never a substitute email.
 */
export const CollabMaskedEmailOffer = ({
  unlockTarget,
}: {
  /** The creator to unlock; null for a batch, which only gets the offer. */
  unlockTarget: ProfileUnlockTarget | null;
}) => {
  const { t } = useTranslation();
  const quota = useProfileUnlockQuota();
  const remaining = quota && quota.limit !== null ? Math.max(quota.limit - quota.used, 0) : 0;

  if (unlockTarget && quota && quota.limit !== null && remaining > 0) {
    return (
      <Stack gap="2">
        <Text fontSize="11.5px" color="fg.muted" lineHeight="1.5">
          {t(`${K}.unlockToSend`)}
        </Text>
        <ContactUnlockButton
          target={unlockTarget}
          quota={{ ...quota, limit: quota.limit }}
          // The unlock refreshes the contact summary, which opens the email row.
          onUnlocked={() => undefined}
        />
      </Stack>
    );
  }

  return <PlanLocksBanner text={t(`${K}.lockedByPlan`)} ctaLabel={t(`${K}.unlockCta`)} />;
};
